module.exports = __webpack_public_path__ + "static/media/bike2.a922b035.jpg";